import React, { useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import axios from 'axios';

const GoogleLoginButton = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const handleSuccess = async (credentialResponse) => {
    try {
      setLoading(true); // loading başlasın
      const decoded = jwtDecode(credentialResponse.credential);
      console.log("Google kullanıcı bilgileri:", decoded);

      // LocalStorage'a kaydet
      localStorage.setItem("googleUser", JSON.stringify(decoded));
      localStorage.setItem("googleToken", credentialResponse.credential);

      // Backende gönder
      await axios.post("http://localhost:5000/api/auth/google", {
        name: decoded.name,
        email: decoded.email,
        picture: decoded.picture,
        sub: decoded.sub, // Google ID
        token: credentialResponse.credential
      });

      // 2 saniye sonra yönlendir
      setTimeout(() => {
        history.push("/home");
      }, 2000);
    } catch (error) {
      console.error("Giriş işlemi sırasında hata oluştu:", error);
      setLoading(false);
    }
  };

  const handleError = () => {
    console.error("Google girişi başarısız oldu.");
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", marginTop: 20, flexDirection: "column", alignItems: "center" }}>
      {loading ? (
        <div>
          <div className="spinner" style={{ marginBottom: 10 }} />
          <div>Başarıyla giriş yapıldı. Lütfen bekleyiniz...</div>
        </div>
      ) : (
        <GoogleLogin
          onSuccess={handleSuccess}
          onError={handleError}
          locale="tr"
          theme="outline"
          size="large"
          shape="pill"
          text="signin_with"
          width="250"
        />
      )}
    </div>
  );
};

export default GoogleLoginButton;
